<template>
  <div class="row">        
    <div style="float: none; margin: 0 auto; margin-bottom:1em">
      <form>
          <div class="form-group" >
            <label>email address</label>
              <input type="email" class="form-control" id="email" placerholder="Enter email">
          </div>
          <div class="form-group" style="margin-bottom:2em;">
            <label>password</label>
              <input type="password" class="form-control" id="password" placerholder="Enter password">
          </div>
          <button type="button" class="btn btn-primary btn-lg" style="" @click.prevent="register">Register</button>
      </form>
    </div>      
  </div>
</template>

<script>
import Firebase from 'firebase'
import { store } from '../store/store.js'

Firebase.auth().onAuthStateChanged(function(user) {
  if(user) {
    store.dispatch('setUser', user)
  } else {
    store.dispatch('setUser', null)
  }
});

export default {
  data() {
      return {
      }
  },
  computed: {
    currentUser(){
      return this.$store.getters.currentUser
    }
  },
  methods: {
    register() {
      var email = document.getElementById('email').value;
      var password = document.getElementById('password').value;

      Firebase.auth().createUserWithEmailAndPassword(email, password).catch(function(error) {
        var errorCode = error.code;
        var errorMessage = error.message;

        if(errorCode === 'auth/wrong-password' ) {
          alert('Wrong password')
        } else {
          alert(errorMessage);
        }
      });
    },
  },
}

</script>


// WEBPACK FOOTER //
// src/components/Register.vue